import {
  REGISTER_CAMPUS_AMBASSADOR_SUCCESS,
  REGISTER_CAMPUS_AMBASSADOR_FAILED,
  REGISTER_CAMPUS_AMBASSADOR
} from '../constants/actionTypes';
import { signUpCampusAmbassador } from '../api/v1/campusAmbassador';

export const addCampusAmbassador = (
  { name, email, phone, semester, college, stream, voucher },
  callback = () => {}
) => {
  return async dispatch => {
    try {
      dispatch({ type: REGISTER_CAMPUS_AMBASSADOR });
      const response = await signUpCampusAmbassador({
        name,
        email,
        phone,
        semester,
        college,
        stream,
        voucher
      });

      if (response) {
        callback(true);
        dispatch({ type: REGISTER_CAMPUS_AMBASSADOR_SUCCESS });
      }

      if (response.errors) {
        throw new Error(response.errors);
      }
    } catch (err) {
      callback(false);
      dispatch({ type: REGISTER_CAMPUS_AMBASSADOR_FAILED, error: err });
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/ambassador.js